<template>
  <v-container>
    <template v-if="success">
      <v-alert outlined type="success">
        <p>Success! Your password has been reset</p>
      </v-alert>

      <router-link
        :to="{ name: 'SignIn' }"
        class="default-btn blue"
      >Login</router-link>
    </template>

    <v-form v-else ref="form" @submit.prevent="onResetPassword">
      <label>New password</label>
      <v-text-field
        :type="showNewPassword ? 'text' : 'password'"
        v-model="user.newPassword"
        label="Enter a new password"
        single-line
        solo
        :rules="newPasswordRules">

        <template v-slot:append>
          <button
            type="button" aria-label="append icon" tabindex="-1"
            class="v-icon notranslate v-icon--link mdi theme--light"
            :class="{ 'mdi-eye': showNewPassword, 'mdi-eye-off': !showNewPassword }"
            @click="showNewPassword = !showNewPassword"
          ></button>
        </template>
      </v-text-field>

      <label>Confirm Password</label>
      <v-text-field
        :type="showConfirmPassword ? 'text' : 'password'"
        v-model="user.confirmPassword"
        label="Re-enter new password"
        single-line
        solo
        :rules="confirmPasswordRules">

        <template v-slot:append>
          <button
            type="button" aria-label="append icon" tabindex="-1"
            class="v-icon notranslate v-icon--link mdi theme--light"
            :class="{ 'mdi-eye': showConfirmPassword, 'mdi-eye-off': !showConfirmPassword }"
            @click="showConfirmPassword = !showConfirmPassword"
          ></button>
        </template>
      </v-text-field>

      <div class="button-group vertical">
        <v-btn
          :disabled="loading"
          class="default-btn blue"
          @click.prevent="onResetPassword"
        >Update Password</v-btn>

        <v-btn
          :to="{ name: 'TermsAndConditions' }"
          class="default-btn text subdued"
        >Terms and Conditions</v-btn>
      </div>
    </v-form>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ResetPassword',
  props: {
    resetId: String,
    resetToken: String,
  },
  data: () => ({
    user: {},
    loading: false,
    success: false,
    showNewPassword: false,
    showConfirmPassword: false,
  }),
  computed: {
    ...mapGetters('feathers', ['apiPasswordResets']),

    newPasswordRules () {
      return [
        v => !!v || 'Password is required.',
        v => (v && v.length >= 6) || 'Password must be less than 6 characters.',
      ]
    },
    confirmPasswordRules () {
      return [
        v => !!v || 'Confirm password is required.',
        v =>
          (v && v.length >= 6) ||
          'Confirm password must be less than 6 characters.',
        v => v === this.user.newPassword || 'Passwords do not match.',
      ]
    },
  },
  methods: {
    async onResetPassword () {
      if (!this.$refs.form.validate() || this.loading) return

      this.loading = true
      try {
        await this.apiPasswordResets.patch(this.resetId, {
          password: this.user.newPassword,
          token: this.resetToken.replace(/[^0-9A-Za-z]/g, ''),
        })

        this.success = true
      } catch (error) {
        this.addAlert({
          type: 'error',
          message: `There was an error resetting your password: ${error.message}`,
        })
      }

      this.loading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.default-btn {
  width: 200px;
}
</style>
